<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 11:04:49
 * @LastEditTime: 2025-10-22 18:18:58
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-operate">
    <div class="c-operate__item" :class="{ 'is-disabled': isDisabled }">
      <IconByTooltip
        :data="{ ...copyData, icon: 'copyIcon', label: '复制' }"
        :copyValue="dataProp.content && dataProp.content[0] ? dataProp.content[0].value : ''"
        @on-change="
          (e) => {
            copyData.isCopy = false;
            copyData.className = 'iconfont icon-a-fuzhimoren';
          }
        "
        class="iconfont_wrap"
        @on-click="
          () => {
            if (isDisabled) return;
            copyData.isCopy = true;
            copyData.className = 'iconfont icon-a-yifuzhimoren';
          }
        "
      ></IconByTooltip>
    </div>
    <div
      class="c-operate__item"
      :class="{ 'is-disabled': isDisabled }"
      v-if="
        $attrs.isShowReset !== undefined
          ? $attrs.isShowReset
          : true
      "
    >
      <IconByTooltip
        :data="{
          className: 'iconfont icon-a-shuaxinmoren',
          placement: 'top',
          label: isDisabled ? '生成中，不可操作' : '重新生成',
          icon: 'congxinshengchengIcon',
        }"
        class="iconfont_wrap"
        @on-click="
          () => {
            if (isDisabled) return;
            $emit('on-reset-question', {
              params: { ...dataProp, index: indexProp },
              formModalData: this.formModalDataProp,
            });
          }
        "
      ></IconByTooltip>
    </div>
    <!-- 分隔线 -->
    <span class="c-operate__divider"></span>
    <!-- 点赞 -->
    <div class="c-operate__item feedback-item" :class="{ 'is-disabled': isDisabled }">
      <el-tooltip effect="dark" placement="top" :content="feedbackState === 'like' ? '取消点赞' : '点赞'">
        <div
          :class="['feedback_btn', 'like-btn', { active: feedbackState === 'like' }]"
          @click.stop="isDisabled || handleFeedback('like')"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 5.5H2.25C1.56 5.5 1 6.06 1 6.75V12.75C1 13.44 1.56 14 2.25 14H3.5V5.5Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.5 14L8 14C8.82843 14 9.5 13.3284 9.5 12.5V10C9.5 9.72386 9.27614 9.5 9 9.5H7L8 6C8.27614 4.89543 7.60457 3.5 6.5 3.5C6.22386 3.5 6 3.72386 6 4V5.5L3.5 5.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </el-tooltip>
    </div>
    <!-- 点踩 -->
    <div class="c-operate__item feedback-item" :class="{ 'is-disabled': isDisabled }">
      <el-tooltip effect="dark" placement="top" :content="feedbackState === 'dislike' ? '取消点踩' : '点踩'">
        <div
          :class="['feedback_btn', 'dislike-btn', { active: feedbackState === 'dislike' }]"
          @click.stop="isDisabled || handleFeedback('dislike')"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: translateY(2px);">
            <path d="M3.5 10.5H2.25C1.56 10.5 1 9.94 1 9.25V3.25C1 2.56 1.56 2 2.25 2H3.5V10.5Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.5 2H8C8.82843 2 9.5 2.67157 9.5 3.5V6C9.5 6.27614 9.27614 6.5 9 6.5H7L8 10C8.27614 11.1046 7.39543 12.5 6.5 12.5C6.22386 12.5 6 12.2761 6 12V10.5L3.5 10.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import IconByTooltip from "@/components/aiChat/components/compose/iconByTooltip.vue";
import { Api } from "@/api";

export default {
  components: {
    IconByTooltip,
  },
  props: {
    dataProp: {
      type: Object,
      default() {
        return {};
      },
    },
    formModalDataProp: {
      type: Object,
      default() {
        return {};
      },
    },
    indexProp: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      copyData: {},
      isLoading: false,
      feedbackState: '',
    };
  },
  watch: {
    dataProp: {
      handler: function (n) {
        this.copyData = JSON.parse(JSON.stringify({ ...n.copyData }));
        // this.isLoading = fetchEventSourceManager.onGetLoading();
      },
      immediate: true,
    },
    formModalDataProp: {
      handler: function (n) {
        if (n && n.responseData && n.responseData.rating !== undefined) {
          const ratingMap = { 1: 'like', 2: 'dislike' };
          this.feedbackState = ratingMap[n.responseData.rating] || '';
        }
      },
      immediate: true,
    },
    copyData: {
      handler: function (n) {},
      deep: true,
    },
  },
  methods: {
    handleFeedback(type) {
      const rating = type === 'like' ? 1 : 2;
      if (this.feedbackState === type) {
        // 取消：传 rating=0 表示取消
        this.feedbackState = '';
        Api.aiRate({ id: this.formModalDataProp.id, rating: 0 }).then(res => {
          if (res.code === '0') {
            this.$message.success('已取消反馈');
          }
        });
      } else {
        this.feedbackState = type;
        Api.aiRate({ id: this.formModalDataProp.id, rating }).then(res => {
          if (res.code === '0') {
            this.$message.success(type === 'like' ? '点赞成功' : '点踩成功');
          }
        });
      }
      this.$emit('on-feedback', {
        type: this.feedbackState,
        params: { ...this.dataProp, index: this.indexProp },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-operate {
  display: flex;
  align-items: center;
 .c-operate__item {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    > i {
      font-size: 16px;
      padding: 2px 4px;
      color: #86909c;
      cursor: pointer;
    }
    &.is-disabled {
      opacity: 0.4;
      cursor: not-allowed;
      pointer-events: none;
    }
    ::v-deep .icon_class_wrap {
      &:hover {
        background-color: #e8f3ff;
        border-radius: 8px;
        .i-class_name {
          color: #165dff;
        }
      }
    }
    &.delete_wrap {
      ::v-deep .icon_class_wrap {
        &:hover {
          background-color: rgba(245, 63, 63, 0.1);
          border-radius: 8px;
          .i-class_name {
            color: #f53f3f;
          }
        }
      }
    }
    .iconfont_wrap {
      ::v-deep .icon_class_wrap {
        padding: 4px;
        height: 24px;
      }
      ::v-deep .congxinshengchengIcon {
        padding: 4px 0;
        height: 24px;
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .c-operate__divider {
    display: inline-block;
    width: 1px;
    height: 14px;
    background: #ECEFF6;
    margin: 0 8px;
    align-self: center;
  }
  .feedback-item {
    display: flex;
    align-items: center;
    height: 24px;
    width: auto !important;
    margin-right: 8px;
  }
  .feedback_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 4px;
    cursor: pointer;
    border-radius: 8px;
    color: #86909C;
    &:hover {
      background-color: #e8f3ff;
      color: #165dff;
    }
    &.active {
      &.like-btn {
        color: #165dff;
      }
      &.dislike-btn {
        color: #F53F3F;
      }
    }
  }
}
</style>